import React from "react";
import styled, { ThemeProvider } from "styled-components";
import Hero from "./Hero";
import WhyUs from "./WhyUs";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import Leaderboard from "./Leaderboard";
import Footer from "./Footer";
import { darkTheme } from "./theme/theme";
import Header from "./Header";
import Layout from "./layout/Layout";
import HowWeWork from "./HowWeWork";
import ProjectsDelivered from "./ProjectDelivered";
import SocialStatsSeparator from "./SocialStatsSeparator";
import AboutEngineerCodewala from "./AboutEngineerCodewala";
import TechnologiesSection from "./TechnologiesSection";
import ProjectsShowcaseHome from "./components/ProjectsShowcaseHome";
import CoursesShowcaseHome from "./CoursesShowcaseHome";
import Roadmap from "./Roadmap";
import RoleBasedRoadmap from "./RoleBaseRoadmap";

const Wrapper = styled.div`
  font-family: "Poppins", sans-serif;
  background: #000;
`;

export default function Home() {
  return (
    <ThemeProvider theme={darkTheme}>
      <Wrapper>
        <Hero />
        <AboutEngineerCodewala />
        <ProjectsShowcaseHome />
        {/* <CoursesShowcaseHome /> */}
        <WhyUs />
        <SocialStatsSeparator />
        <Roadmap />
        <HowWeWork />
        <TechnologiesSection />
        <RoleBasedRoadmap />
      </Wrapper>
    </ThemeProvider>
  );
}
